import React from "react";
import "./SocialMediaBar.css";
import { FaFacebook, FaInstagram, FaYoutube, FaLinkedin } from "react-icons/fa";

export default function SocialMediaBar() {
  return (
    <div className="social-navbar">
      <div className="navbar-title">Welcome to Edu-Tech Master Academy</div>
      <div className="social-icons">
        <a href="https://www.facebook.com/profile.php?id=61555808285747">
          {" "}
          <FaFacebook />
        </a>
        <a href="https://www.instagram.com/edutechmasteracademy/?hl=en">
          <FaInstagram />
        </a>
        <a href="url(https://l.instagram.com/?u%3Dhttp%3A%2F%2Fyoutube.com%2F%40EduTechMasterAcademy%3Ffbclid%3DPAZXh0bgNhZW0CMTEAAad7KQirriyxww9QFUx6hhNMzpI6aHZ5zPNvvRB8mg4rtx3JhjSbHO6NIAe3yg_aem_O6XwsQwjvydeJKJ95De0Rw%26e%3DAT0-xt6ZZgTHQbZiStCvsrFEa0qidMPfyXftmIfKJyCNlgF7aw2Q1JCe6VoPBDBfVKBux6SZcMTb71tgT3KcNxHR2BhXIwgAv15lh-3t4w)">
          <FaYoutube />
        </a>
        <a
          href="https://www.linkedin.com/in/edutechmaster-academy/"
          aria-label="LinkedIn"
        >
          <FaLinkedin />
        </a>
      </div>
    </div>
  );
}
